/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuditUsers } from '../models/AuditUsers';
import type { MilestonePasswordReset } from '../models/MilestonePasswordReset';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import type { UserCreate } from '../models/UserCreate';
import type { UserDetails } from '../models/UserDetails';
import type { UserLoginAttemptDetails } from '../models/UserLoginAttemptDetails';
import type { UserUpdate } from '../models/UserUpdate';
import { request as __request } from '../core/request';

export class UsersVService {

    /**
     * @param requestBody
     * @returns UserDetails Created
     * @throws ApiError
     */
    public static async usersVCreate(
        requestBody?: UserCreate,
    ): Promise<UserDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/users`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async usersVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/users/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns UserDetails OK
     * @throws ApiError
     */
    public static async usersVGetExport(
        requestBody?: PagingQuery,
    ): Promise<UserDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/users/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async usersVGetLoginAttemptsById(
        userId: string,
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/users/${userId}/LoginAttempts/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @param requestBody
     * @returns UserLoginAttemptDetails OK
     * @throws ApiError
     */
    public static async usersVGetLoginExport(
        userId: string,
        requestBody?: PagingQuery,
    ): Promise<UserLoginAttemptDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/users/${userId}/LoginAttempts/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @param requestBody
     * @returns UserDetails OK
     * @throws ApiError
     */
    public static async usersVUpdateUser(
        userId: string,
        requestBody?: UserUpdate,
    ): Promise<UserDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/users/${userId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @returns UserDetails OK
     * @throws ApiError
     */
    public static async usersVGetUser(
        userId: string,
    ): Promise<UserDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/users/${userId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @returns any No Content
     * @throws ApiError
     */
    public static async usersVDeactivate(
        userId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v2/users/${userId}`,
            errors: {
                400: `Bad Request`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @returns UserDetails Created
     * @throws ApiError
     */
    public static async usersVReactivate(
        userId: string,
    ): Promise<UserDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/users/${userId}`,
        });
        return result.body;
    }

    /**
     * @param userId
     * @param requestBody
     * @returns UserDetails OK
     * @throws ApiError
     */
    public static async usersVPasswordChange(
        userId: string,
        requestBody?: MilestonePasswordReset,
    ): Promise<UserDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/users/${userId}/Password/Reset`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns AuditUsers OK
     * @throws ApiError
     */
    public static async usersVGetAllByUserIds(
        requestBody?: Array<string>,
    ): Promise<Array<AuditUsers>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/users/audit`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param userIds
     * @returns any No Content
     * @throws ApiError
     */
    public static async usersVDeactivateAll(
        userIds: Array<string>,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v2/users/deactivate`,
        });
        return result.body;
    }

}